module.exports = __webpack_public_path__ + "static/media/right.19fc4ff4.mp3";